// Wrapper Box for unauthed pages that have a single centered form
import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import styled from "styled-components";
import { toastContainer } from "screens/shared/toast";

const Outer = styled.div`
  ${tw`mx-auto px-8`}
  max-width: 1448px;
`;

const Inner = styled.div`
  ${tw`flex justify-center items-center pt-6 h-full`}
  transition: all 0.3s ease-in-out;
  z-index: 2;
`;

const Box = (props) => (
  <Outer>
    {toastContainer()}
    <Inner>
      <div>{props.children}</div>
    </Inner>
  </Outer>
);

Box.propTypes = {
  children: PropTypes.any
};

export default Box;
